var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"box"}},[_c('div',{staticClass:"tabBox"},[_c('div',{staticClass:"centerBox"},[_vm._m(0),_c('div',{staticClass:"imgBack"},_vm._l((_vm.list),function(item,index){return _c('a',{key:index,attrs:{"target":"_blank","href":item.url}},[_c('img',{attrs:{"src":item.img,"alt":""}})])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v("支持单位")])])
}]

export { render, staticRenderFns }